import React, { Component } from 'react';
import { connect } from 'react-redux';

import { joinCommittee , removeCommittee, isUserLoggedIn, setLoadingState } from '../actions/index';
import '../global';

class CommitteeButton extends Component {

	loadSpinner(){
		return (<button type="button"  className="btn btn-primary join-committee-btn disabled">
					<img className="spinner" src={getAjaxLoader()}/>
				</button>);
	}

	isLoading(ccode){
		if(this.props.loadingState.includes(ccode)){
			return true;
		} else{
			return false;
		}
	}


	handleClick( joinLeave, event ) {

		this.props.setLoadingState(event.target.dataset.code);
		if(joinLeave === 'join') {
			this.props.joinCommittee( event.target.dataset.code, ISDA_Main.partyId, this.props.myCommittees, this.props.committee.openToNonMembers );
		} else{
			this.props.removeCommittee(event.target.dataset.code, ISDA_Main.partyId, this.props.myCommittees);
		}

	}

	render() {
		const committee    = this.props.committee;
		const committeeCode = committee.code;
		const myCommittees  = this.props.myCommittees;
		const requestedCommittees = this.props.requestedCommittees;
		const inMyCommittees = myCommittees.includes(committeeCode);
		const inRequestCommittees = requestedCommittees.includes(committeeCode);

		if ( !isUserLoggedIn()  || (!is_member() && ! (inMyCommittees || inRequestCommittees ) && committee.openToNonMembers !== '1') ) {
			return (<button type="button" name="join-committee" data-code={ committeeCode } className="btn btn-primary join-committee-btn" disabled>Join</button>);
		}

		if(this.isLoading(committeeCode)){
			return (this.loadSpinner());
		}

		if ( inMyCommittees ) {
			return (
				<button type="button"
				        name="join-committee"
				        onClick={ this.handleClick.bind( this, 'leave' ) }
				        data-code={ committeeCode }
				        data-type={'leave'}
				        className="btn btn-primary join-committee-btn">Leave</button>
			);
		} else if(inRequestCommittees) {
				return (
				<button type="button"
				        name="cancel-request"
				        onClick={ this.handleClick.bind( this, 'leave' ) }
				        data-code={ committeeCode }
				        data-type={'cancel'}
				        className="btn btn-primary join-committee-btn cancel-request">Cancel Request</button>
				);
1271
		} else if (committee.inviteOnly == '1'){
				return (
				       <button type="button"
				name="join-committee"
				onClick={ this.handleClick.bind( this, 'join' ) }
				data-code={ committeeCode }
        data-type={'request'}
				className="btn join-committee-btn">Join</button>
			);
		} else {
			return (
			<button type="button"
			        name="join-committee"
			        onClick={ this.handleClick.bind( this, 'join' ) }
			        data-code={ committeeCode }
			        data-type={'join'}
			        className="btn join-committee-btn">Join</button>
		);
	}


	}
}



function mapStateToProps( { requestedCommittees, myCommittees,  message, currentTabs, loadingState } ) {
	return { requestedCommittees, myCommittees,  message, currentTabs , loadingState };
}

export default connect( mapStateToProps, { joinCommittee, removeCommittee, setLoadingState } )( CommitteeButton );